export function numberDigits() {
  let numberInputs = $('.number-input');
  let numberRegExp = /\d+/g;

  numberInputs.each(function (index, input) {
    input.addEventListener('input', function () {
      this.value = this.value.match(numberRegExp);
    });
  });
}

export function phoneDigits() {
  let phoneInputs = $('.phone-input');
  let phoneRegExp = /^[+]\d+|^[+]/g;

  phoneInputs.each(function (index, input) {
    input.addEventListener('input', function () {
      this.value = this.value.match(phoneRegExp);
    });
  });
}

export function engineDigit(engine) {
  let engineRegExp = /^\d[,.]?\d?/g;
  let engineFixRegExp = /^\d\./g;
  let engineRegExpZero = /^0[,.]0/g;

  if (engine) {

    engine.addEventListener('input', function () {
      if (engineRegExpZero.test(this.value)) {
        this.value = '0';
      }
      if (parseInt(this.value) <= 10) {
        this.value = this.value.match(engineRegExp);
      } else if (isNaN(parseInt(this.value))) {
        this.value = '';
      } else {
        this.value = '10';
      }
    });

    engine.addEventListener('change', function () {
      if (engineFixRegExp.test(this.value)) {
        this.value = this.value.replace(coma, '')
      }
    })
  }
}

export function enableSendButton() {
  let sendReportBtn = $('#send-report-button');
  sendReportBtn.removeClass('gray');
  sendReportBtn.addClass('red');
  sendReportBtn.prop('disabled', false);
}



// WEBPACK FOOTER //
// ./app/webpacker/src/js/modules/validations.js